export const PAGES_MENU_FREELANCER = [
  {
    path: 'pages',
    children: [
      {
        path: 'dashboard',
        data: {
          menu: {
            title: 'Dashboard',
            icon: 'fa fa-home',
            selected: false,
            expanded: false,
            order: 0
          }
        }
      },
      {
        path: 'listofferpremium',
        data: {
          menu: {
            title: 'Ofertas',
            icon: 'fa fa-briefcase',
            selected: false,
            expanded: false,
            order: 0
          }
        }
      },
      {
        path: 'listofferfreelancer',
        data: {
          menu: {
            title: 'Proyectos',
            icon: 'fa fa-briefcase',
            selected: false,
            expanded: false,
            order: 0
          }
        }
      },
      {
        path: 'candidates',
        data: {
          menu: {
            title: 'Mis Postulados',
            icon: 'fa fa-eye',
            selected: false,
            expanded: false,
            order: 0
          }
        }
      },
      {
        path: 'candidates_map',
        data: {
          menu: {
            title: 'Base Datos HV',
            icon: 'fa fa-map',
            selected: false,
            expanded: false,
            order: 0
          }
        }
      },
      {
        path: 'message',
        data: {
          menu: {
            title: 'Mensajes',
            icon: 'fa fa-comment',
            selected: false,
            expanded: false,
            order: 0
          }
        }
      },
      // {
      //   path: 'checkdoclist',
      //   data: {
      //     menu: {
      //       title: 'Documentos',
      //       icon: 'fa fa-folder-open-o',
      //       selected: false,
      //       expanded: false,
      //       order: 0
      //     }
      //   }
      // },
      {
        path: 'reports',
        data: {
          menu: {
            title: 'Reportes',
            icon: 'fa fa-pie-chart',
            selected: false,
            expanded: false,
            order: 0
          }
        }
      },
    ]
  }
];



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/pages.menu.freelancer.ts